
import { defineComponent,PropType,ref,watch,Ref, onMounted } from 'vue'
export default defineComponent({
  name:"ImageSearching",
  props:{  
    width:{
      type:Number,
      default:200
    },
    fileType:{
      type:Number,
      default:0,
    },
    height:{
      type:Number,
      default:160      
    },
    url:{
      type:String, 
      default:''    
    },
    oriUrl:{
      type:String, 
      default:''   
    },
    file:{
      type:String
          
    },
    id:{
      type:Number,
    },
    index:{
      type:String,
    },
    showDel:{
      type:Boolean,
      default:true    
    }
  },
  setup(props, { emit }) {
    const isFull = ref(false)
    // const displayImage = ref<HTMLInputElement|null>(null);
    const fulldisplayImageSrc = ref<string>();
    const viewimg = (val) =>{      
      emit('search',props.id)
    }
    const deleteImg = () =>{
      emit('delimg',{index:props.index,id:props.id})
    }
    onMounted(()=>{    
        console.log(props.fileType)
    })
    
    return{
      props,viewimg,deleteImg,isFull,fulldisplayImageSrc,emit
    }
  },
})
